<template>
  <div class="navbar">
    <hamburger
      id="hamburger-container"
      :is-active="sidebar.opened"
      class="hamburger-container"
      @toggleClick="toggleSideBar"
    />

    <!--    <breadcrumb id="breadcrumb-container" class="breadcrumb-container" />-->
    <div class="store-box">
      <p class="store_list" v-if="userInfo.type!=1">
      <span
        v-for="(store,index) in storeList"
        :key="index"
        :class="{active:store.storeId===storeNow.storeId}"
        @click="storeChange(store)"
      >{{ store.storeName }}</span>
      </p>
    </div>

    <div class="right-menu">
      <!--      <template v-if="device!=='mobile'">-->
      <!--        <search id="header-search" class="right-menu-item" />-->

      <!--        <error-log class="errLog-container right-menu-item hover-effect" />-->

      <!--        <screenfull id="screenfull" class="right-menu-item hover-effect" />-->

      <!--        <el-tooltip content="Global Size" effect="dark" placement="bottom">-->
      <!--          <size-select id="size-select" class="right-menu-item hover-effect" />-->
      <!--        </el-tooltip>-->

      <!--      </template>-->

      <el-dropdown class="avatar-container right-menu-item hover-effect" trigger="click">
        <div style="text-align: center">
          {{ roles }}<i class="el-icon-caret-bottom" />
        </div>
        <!--        <div class="avatar-wrapper">-->
        <!--          <div>{{ roles }}</div>-->
        <!--          <el-avatar src="https://ss3.bdstatic.com/70cFv8Sh_Q1YnxGkpoWK1HF6hhy/it/u=3846290151,2766954484&fm=26&gp=0.jpg" :size="40" icon="el-icon-user-solid" />-->
        <!--          <img :src="avatar+'?imageView2/1/w/80/h/80'" alt="用户头像" class="user-avatar">-->
        <!--          <i class="el-icon-caret-bottom" />-->
        <!--        </div>-->
        <el-dropdown-menu slot="dropdown">
          <!--          <router-link to="/">-->
          <!--            <el-dropdown-item>Dashboard</el-dropdown-item>-->
          <!--          </router-link>-->
          <el-dropdown-item>
            <span style="display:block;" @click="resetPsw">修改密码</span>
          </el-dropdown-item>
          <el-dropdown-item divided @click.native="logout">
            <span style="display:block;">退出登录</span>
          </el-dropdown-item>
        </el-dropdown-menu>
      </el-dropdown>
      <el-dialog
        title="修改密码"
        :visible.sync="dialogVisible"
        width="500px"
        :before-close="handleClose"
      >
        <div>
          <el-form ref="ruleForm" :model="datas" :rules="rules" label-width="100px" class="demo-ruleForm">
            <el-form-item label="原密码" prop="oldPsw">
              <el-input v-model="datas.oldPsw" type="password" />
            </el-form-item>
            <el-form-item label="新密码" prop="newPsw">
              <el-input v-model="datas.newPsw" type="password" />
            </el-form-item>
            <el-form-item label="确认密码" prop="secondPsw">
              <el-input v-model="datas.secondPsw" type="password" />
            </el-form-item>
          </el-form>
          <el-button style="margin-left: 360px" type="primary" @click="submitForm('ruleForm')">立即修改</el-button>
        </div>
        <!--        <span slot="footer" class="dialog-footer">-->
        <!--          <el-button @click="dialogVisible = false">取 消</el-button>-->
        <!--          <el-button type="primary" @click="dialogVisible = false">确 定</el-button>-->
        <!--        </span>-->
      </el-dialog>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
// import Breadcrumb from '@/components/Breadcrumb'
import Hamburger from '@/components/hamburger/Index'
// import ErrorLog from '@/components/ErrorLog'
// import Screenfull from '@/components/Screenfull'
// import SizeSelect from '@/components/SizeSelect'
// import Search from '@/components/HeaderSearch'
// import menu from '@/layout/components/Sidebar/SidebarItem'
// import nav from '@/layout/components/TagsView/index'
import {upDatePass} from '../../../api/modules/system'

export default {
  components: {
    // Breadcrumb,
    Hamburger
    // ErrorLog
    // Screenfull
    // SizeSelect
    // Search
  },
  data() {
    return {
      dialogVisible: false,
      datas: {
        oldPsw: '',
        newPsw: '',
        secondPsw: ''
      },
      rules: {
        oldPsw: [
          { required: true, message: '请输入原密码', trigger: 'blur' }
        ],
        newPsw: [
          { required: true, message: '请输入6~20位新密码', trigger: 'blur' }
        ],
        secondPsw: [
          { required: true, message: '请输入确认密码', trigger: 'blur' }
        ]
      },
      storeNow: {}

    }
  },
  computed: {
    ...mapGetters([
      'sidebar',
      'avatar',
      'device',
      'storeInfo',
      'storeList',
      'roles',
      'userInfo'
    ])
  },
  mounted() {
    this.storeNow = this.storeInfo
    if (window.sessionStorage.getItem('storeInfoNow') && window.sessionStorage.getItem('isChangeStore')){
      window.sessionStorage.setItem('isChangeStore','')
      this.storeNow = JSON.parse(window.sessionStorage.getItem('storeInfoNow'))
      this.$store.dispatch('store/changeStore', this.storeNow)
    }
  },
  methods: {
    // 刷新当前路由
    refreshSelectedTag(view) {
      this.$store.dispatch('tagsView/delCachedView', view).then(() => {
        const { fullPath } = view
        this.$nextTick(() => {
          this.$router.replace({
            path: '/redirect' + fullPath
          })
        })
      })
    },
    // 改变店铺选择状态
    async storeChange(store) {
      if (store.storeId === this.storeNow.storeId) return
      this.$router.push({path: '/'})
      await this.$store.dispatch('store/changeStore', store)
      window.sessionStorage.setItem('isChangeStore','1')
      window.sessionStorage.setItem('storeInfoNow',JSON.stringify(store))
      this.storeNow = store
      // menu.data.datas = '/'
      // 关闭所有tag
      this.closeAllTags()
      this.refreshSelectedTag(this.$route)
      // menu.methods.changeColor()
    },
    closeAllTags() {
      this.$store.dispatch('tagsView/delAllViews')
    },
    toggleSideBar() {
      this.$store.dispatch('app/toggleSideBar')
    },
    async logout() {
      await this.$store.dispatch('user/logout')
      window.sessionStorage.clear()
      // window.sessionStorage.setItem('storeInfoNow','{}')
      this.$router.push(`/login?redirect=${this.$route.fullPath}`)
    },
    // 重置密码
    resetPsw() {
      this.dialogVisible = true
    },
    // 重置密码关闭
    handleClose(done) {
      this.$confirm('确认关闭？')
        .then(() => {
          this.datas.newPsw = ''
          this.datas.oldPsw = ''
          this.datas.secondPsw = ''
          done()
        })
        .catch(() => {})
    },
    submitForm(formName) {
      if (this.datas.newPsw !== this.datas.secondPsw) {
        this.$message.error('两次输入密码不一致！！！')
        return
      }
      if (this.datas.newPsw.length < 6 || this.datas.newPsw.length > 20 ) {
        this.$message.warning('请输入6~20位新密码')
        return
      }
      this.$refs[formName].validate((valid) => {
        if (valid) {
          const obj = {}
          obj.oldPass = this.datas.oldPsw
          obj.newPass = this.datas.newPsw
          upDatePass(obj).then(() => {
            this.dialogVisible = false
            this.$message.success('密码修改成功！请重新登录！！')
            setTimeout(()=>{
              this.logout()
            },1500)

          }).catch(err=>{
            this.$message.error(err.msg || '网络开小差，请稍后重试')
          })
        } else {
          console.log('error submit!!')
          return false
        }
      })
    }

  }
}
</script>

<style lang="scss" scoped>
.store_list {
  float: left;
  margin: 0;
  height: 50px;
  line-height: 50px;
  cursor: pointer;
  width: calc(100% - 250px);
  white-space: nowrap;
  overflow-x: scroll;
  overflow-y: hidden;

  span {
    color: #666;
    padding: 0 20px;
    display: inline-block;

    &.active {
      color: #047BFD;
      font-weight: bold;
    }
  }
}

.navbar {
  height: 50px;
  overflow: hidden;
  position: relative;
  background: #fff;
  box-shadow: 0 1px 4px rgba(0, 21, 41, .08);

  .hamburger-container {
    line-height: 46px;
    height: 100%;
    float: left;
    cursor: pointer;
    transition: background .3s;
    -webkit-tap-highlight-color: transparent;

    &:hover {
      background: rgba(0, 0, 0, .025)
    }
  }

  .breadcrumb-container {
    float: left;
  }

  .errLog-container {
    display: inline-block;
    vertical-align: top;
  }

  .right-menu {
    float: right;
    height: 100%;
    line-height: 50px;

    &:focus {
      outline: none;
    }

    .right-menu-item {
      display: inline-block;
      padding: 0 8px;
      height: 100%;
      font-size: 18px;
      color: #5a5e66;
      vertical-align: text-bottom;

      &.hover-effect {
        cursor: pointer;
        transition: background .3s;

        &:hover {
          background: rgba(0, 0, 0, .025)
        }
      }
    }

    .avatar-container {
      margin-right: 30px;

      .avatar-wrapper {
        margin-top: 5px;
        position: relative;

        .user-avatar {
          cursor: pointer;
          width: 40px;
          height: 40px;
          border-radius: 10px;
        }

        .el-icon-caret-bottom {
          cursor: pointer;
          position: absolute;
          right: -20px;
          top: 25px;
          font-size: 12px;
        }
      }
    }
  }
}
/deep/ .el-dialog__header{
  line-height: 24px;
  height: 48px;
}

/*滚动条样式*/
.store_list::-webkit-scrollbar {
  //width: 2px;
  width: 6px; // 横向滚动条
  height: 6px; // 纵向滚动条 必写
  /*height: 4px;*/
}
.store_list::-webkit-scrollbar-thumb {
  height: 2px;
  width: 30px;
  border-radius: 3px;
  background-color: #ccc;
}
.store_list::-webkit-scrollbar-track {
  height: 2px;
  border-radius: 0;
  background-color: #fff;

}
</style>
